import * as React from "react";
import { forwardRef } from "react";
const SvgDraft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none", viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#98A9BC", fillRule: "evenodd", d: "M0 0v18h18V0zm1.636 1.636h14.728v14.728H1.636zm2.455 2.455v1.636h9.818V4.091zm0 4.09v1.637h9.818V8.182zm0 4.092v1.636H9v-1.636z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgDraft);
export { ForwardRef as ReactComponent };
